// hooks/useTranslationCellKeyboard.ts
import { useCallback } from "react";

interface UseTranslationCellKeyboardProps {
  params: any;
  onSave: (forceMode?: boolean) => void;
}

export const useTranslationCellKeyboard = ({ params, onSave }: UseTranslationCellKeyboardProps) => {
  const handleKeyDown = useCallback((e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    // Prevent propagation for Enter key (Instead of submitting, it'll add move to next line)
    if (e.key === "Enter") {
      e.stopPropagation();
    }
    
    // Prevent propagation for Escape key (to stop editing)
    if (e.key === "Escape") {
      e.stopPropagation();
      params.api.stopCellEditMode({ id: params.id, field: params.field, ignoreModifications: true });
      return;
    }
    
    // Ctrl + Enter key to submit changes
    if ((e.ctrlKey || e.metaKey) && e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      params.api.stopCellEditMode({ id: params.id, field: params.field });
      onSave(false);
      return;
    }
    
    // Alt + Enter key to force save changes
    if (e.altKey && e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      params.api.stopCellEditMode({ id: params.id, field: params.field });
      onSave(true);
      return;
    }
    
    // Tab key to insert tab character
    if (e.key === "Tab") {
      e.preventDefault();
      e.stopPropagation();
      const textarea = e.target as HTMLTextAreaElement;
      const value = textarea.value;
      const selectionStart = textarea.selectionStart;
      const selectionEnd = textarea.selectionEnd;
      const newValue = value.substring(0, selectionStart) + "\t" + value.substring(selectionEnd);
      params.api.setEditCellValue({
        id: params.id,
        field: params.field,
        value: newValue,
      });
      setTimeout(() => {
        textarea.selectionStart = textarea.selectionEnd = selectionStart + 1;
      }, 0);
    }
  }, [params, onSave]);

  return { handleKeyDown };
};